import React, { useState, useEffect, useRef } from 'react';
import {
    fetchBusinessInfo, fetchBusinessPresentation,
    updateBusinessInfo, updateBusinessPresentation, uploadAndSetLogo,
} from '../../bridge';
import ManagedServiceBanner from './ManagedServiceBanner';

const COUNTRY_CODES = [
    '+1', '+7', '+20', '+27', '+30', '+31', '+32', '+33', '+34', '+36',
    '+39', '+40', '+41', '+43', '+44', '+45', '+46', '+47', '+48', '+49',
    '+51', '+52', '+53', '+54', '+55', '+56', '+57', '+58', '+60', '+61',
    '+62', '+63', '+64', '+65', '+66', '+81', '+82', '+84', '+86', '+90',
    '+91', '+92', '+93', '+94', '+95', '+98', '+212', '+213', '+216',
    '+218', '+220', '+221', '+222', '+223', '+224', '+225', '+226', '+227',
    '+228', '+229', '+230', '+231', '+232', '+233', '+234', '+235', '+236',
    '+237', '+238', '+239', '+240', '+241', '+242', '+243', '+244', '+245',
    '+246', '+247', '+248', '+249', '+250', '+251', '+252', '+253', '+254',
    '+255', '+256', '+257', '+258', '+260', '+261', '+262', '+263', '+264',
    '+265', '+266', '+267', '+268', '+269', '+290', '+291', '+297', '+298',
    '+299', '+350', '+351', '+352', '+353', '+354', '+355', '+356', '+357',
    '+358', '+359', '+370', '+371', '+372', '+373', '+374', '+375', '+376',
    '+377', '+378', '+380', '+381', '+382', '+385', '+386', '+387', '+389',
    '+420', '+421', '+423', '+500', '+501', '+502', '+503', '+504', '+505',
    '+506', '+507', '+508', '+509', '+590', '+591', '+592', '+593', '+594',
    '+595', '+596', '+597', '+598', '+599', '+670', '+672', '+673', '+674',
    '+675', '+676', '+677', '+678', '+679', '+680', '+681', '+682', '+683',
    '+685', '+686', '+687', '+688', '+689', '+690', '+691', '+692', '+850',
    '+852', '+853', '+855', '+856', '+880', '+886', '+960', '+961', '+962',
    '+963', '+964', '+965', '+966', '+967', '+968', '+970', '+971', '+972',
    '+973', '+974', '+975', '+976', '+977', '+992', '+993', '+994', '+995',
    '+996', '+998',
];

// ── SVG icons ─────────────────────────────────────────────────────────────────
const IconEdit    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;
const IconCheck   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>;
const IconClose   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IconPerson  = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
const IconStar    = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>;
const IconInfo    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>;
const IconStore   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>;
const IconMap     = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>;
const IconGlobe   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>;
const IconPhone   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.18 2 2 0 0 1 3.59 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.27a16 16 0 0 0 6.29 6.29l.87-.87a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>;
const IconChat    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>;

// ── Small header icon button (matches Flutter _HeaderButton) ─────────────────
const HdrBtn = ({ onClick, variant, children, disabled }) => (
    <button
        className={`hdr-icon-btn hdr-icon-btn-${variant}`}
        onClick={onClick}
        disabled={disabled}
    >
        {children}
    </button>
);

// ── Business Info Card ────────────────────────────────────────────────────────
const BusinessInfoCard = ({ email }) => {
    const logoInputRef = useRef(null);
    const [logoUrl, setLogoUrl]             = useState('');
    const [logoUploading, setLogoUploading] = useState(false);
    const [editMode, setEditMode]           = useState(false);
    const [saving, setSaving]               = useState(false);

    const [businessName,     setBusinessName]     = useState('');
    const [businessAddress,  setBusinessAddress]  = useState('');
    const [businessPhone,    setBusinessPhone]    = useState('');
    const [businessWhatsapp, setBusinessWhatsapp] = useState('');
    const [countryCode,      setCountryCode]      = useState('+1');
    const [website,          setWebsite]          = useState('');

    // Draft copies used while editing
    const [draftName,     setDraftName]     = useState('');
    const [draftAddress,  setDraftAddress]  = useState('');
    const [draftPhone,    setDraftPhone]    = useState('');
    const [draftWhatsapp, setDraftWhatsapp] = useState('');
    const [draftCode,     setDraftCode]     = useState('+1');
    const [draftWebsite,  setDraftWebsite]  = useState('');

    useEffect(() => {
        fetchBusinessInfo(email).then(info => {
            if (!info) return;
            setLogoUrl(info.business_logo || '');
            setBusinessName(info.business_name || '');
            setBusinessAddress(info.business_address || '');
            setBusinessPhone(info.business_phone || '');
            setBusinessWhatsapp(info.business_whatsapp || '');
            setCountryCode(info.country_code || '+1');
            setWebsite(info.website || '');
            // Auto open edit for new accounts
            if (!info.business_name && !info.business_address && !info.business_phone) {
                setEditMode(true);
            }
        });
    }, [email]); // eslint-disable-line react-hooks/exhaustive-deps

    const openEdit = () => {
        setDraftName(businessName); setDraftAddress(businessAddress);
        setDraftPhone(businessPhone); setDraftWhatsapp(businessWhatsapp);
        setDraftCode(countryCode); setDraftWebsite(website);
        setEditMode(true);
    };

    const handleCancel = () => setEditMode(false);

    const handleSave = async () => {
        setSaving(true);
        await updateBusinessInfo(email, {
            businessName: draftName, businessAddress: draftAddress,
            businessPhone: draftPhone, businessWhatsapp: draftWhatsapp,
            countryCode: draftCode, website: draftWebsite,
        });
        setBusinessName(draftName); setBusinessAddress(draftAddress);
        setBusinessPhone(draftPhone); setBusinessWhatsapp(draftWhatsapp);
        setCountryCode(draftCode); setWebsite(draftWebsite);
        setSaving(false);
        setEditMode(false);
    };

    const handleLogoUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setLogoUploading(true);
        const url = await uploadAndSetLogo(email, file);
        if (url) setLogoUrl(url);
        setLogoUploading(false);
        e.target.value = '';
    };

    const isNewUser = !businessName && !businessAddress && !businessPhone && !website;

    return (
        <div className="manage-card">
            {/* Logo + info row */}
            <div className="biz-info-top">
                <div className="biz-logo-col">
                    <div className="biz-logo-frame">
                        {logoUrl
                            ? <img src={logoUrl} alt="Logo" className="biz-logo-img" />
                            : <div className="biz-logo-placeholder">🏪</div>
                        }
                    </div>
                    <input ref={logoInputRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleLogoUpload} />
                    <button className="logo-replace-btn" onClick={() => logoInputRef.current.click()} disabled={logoUploading}>
                        {logoUploading ? '…' : 'Replace Logo'}
                    </button>
                </div>

                <div className="biz-info-col">
                    {!editMode ? (
                        <>
                            {businessName && <p className="biz-display-name">{businessName}</p>}
                            {businessAddress && <p className="biz-display-row"><IconMap />{businessAddress}</p>}
                            {website && <p className="biz-display-row"><IconGlobe />{website}</p>}
                            {businessPhone && <p className="biz-display-row"><IconPhone />{countryCode} {businessPhone}</p>}
                            {businessWhatsapp && <p className="biz-display-row"><IconChat />{businessWhatsapp}</p>}
                            {!businessName && !businessAddress && !businessPhone && (
                                <p style={{ fontSize: 13, color: '#9C8677', margin: 0 }}>No details yet — tap Edit to add them.</p>
                            )}
                        </>
                    ) : null}
                </div>

                {!editMode && (
                    <HdrBtn variant="edit" onClick={openEdit}>
                        <IconEdit />
                    </HdrBtn>
                )}
            </div>

            {/* Edit form */}
            {editMode && (
                <div style={{ marginTop: 16 }}>
                    {isNewUser && (
                        <div className="info-notice">
                            <IconInfo />
                            <span>Fill in your business details so customers can find you.</span>
                        </div>
                    )}

                    {/* Cancel / Save row */}
                    <div className="biz-edit-actions">
                        <button className="biz-cancel-btn" onClick={handleCancel} disabled={saving}>
                            <IconClose /> Cancel
                        </button>
                        <button className="biz-save-btn" onClick={handleSave} disabled={saving}>
                            <IconCheck /> {saving ? 'Saving…' : 'Save'}
                        </button>
                    </div>

                    <div className="manage-form" style={{ marginTop: 14 }}>
                        <div className="input-icon-wrap">
                            <span className="input-icon"><IconStore /></span>
                            <input className="manage-input with-icon" value={draftName} onChange={e => setDraftName(e.target.value)} placeholder="Business name" />
                        </div>
                        <div className="input-icon-wrap">
                            <span className="input-icon"><IconMap /></span>
                            <input className="manage-input with-icon" value={draftAddress} onChange={e => setDraftAddress(e.target.value)} placeholder="Street, City, Country" />
                        </div>
                        <div className="input-icon-wrap">
                            <span className="input-icon"><IconGlobe /></span>
                            <input className="manage-input with-icon" value={draftWebsite} onChange={e => setDraftWebsite(e.target.value)} placeholder="https://yoursite.com" type="url" />
                        </div>
                        <div className="manage-form-row" style={{ gap: 8 }}>
                            <div className="input-icon-wrap" style={{ flex: '0 0 100px' }}>
                                <span className="input-icon"><IconPhone /></span>
                                <select className="manage-input with-icon" value={draftCode} onChange={e => setDraftCode(e.target.value)} style={{ cursor: 'pointer' }}>
                                    {COUNTRY_CODES.map(c => <option key={c} value={c}>{c}</option>)}
                                </select>
                            </div>
                            <div className="input-icon-wrap" style={{ flex: 1 }}>
                                <span className="input-icon"><IconPhone /></span>
                                <input className="manage-input with-icon" value={draftPhone} onChange={e => setDraftPhone(e.target.value)} placeholder="Phone" type="tel" />
                            </div>
                        </div>
                        <div className="input-icon-wrap">
                            <span className="input-icon"><IconChat /></span>
                            <input className="manage-input with-icon" value={draftWhatsapp} onChange={e => setDraftWhatsapp(e.target.value)} placeholder="WhatsApp number" type="tel" />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

// ── Gradient section card (About Us / Our Services) ───────────────────────────
const SectionCard = ({ title, icon, gradient, bodyShadow, savedText, onSave }) => {
    const [text, setText]         = useState(savedText);
    const [editMode, setEditMode] = useState(false);
    const [draft, setDraft]       = useState('');
    const [saving, setSaving]     = useState(false);

    // Sync if parent provides updated savedText after mount
    useEffect(() => { if (!editMode) setText(savedText); }, [savedText, editMode]);

    const openEdit = () => { setDraft(text); setEditMode(true); };
    const handleCancel = () => { setText(savedText); setEditMode(false); };
    const handleSave = async () => {
        setSaving(true);
        await onSave(draft);
        setText(draft);
        setSaving(false);
        setEditMode(false);
    };

    return (
        <div className="section-card" style={{ boxShadow: bodyShadow }}>
            {/* Gradient header */}
            <div className="section-header" style={{ background: gradient }}>
                <div className="section-header-icon">{icon}</div>
                <span className="section-header-title">{title}</span>
                <div style={{ display: 'flex', gap: 6, marginLeft: 'auto' }}>
                    {editMode ? (
                        <>
                            <HdrBtn variant="cancel" onClick={handleCancel} disabled={saving}><IconClose /></HdrBtn>
                            <HdrBtn variant="save"   onClick={handleSave}   disabled={saving}><IconCheck /></HdrBtn>
                        </>
                    ) : (
                        <HdrBtn variant="edit-ghost" onClick={openEdit}><IconEdit /></HdrBtn>
                    )}
                </div>
            </div>

            {/* Body */}
            <div className="section-body">
                {editMode ? (
                    <textarea
                        className="manage-textarea"
                        value={draft}
                        onChange={e => setDraft(e.target.value)}
                        placeholder={`Write your ${title.toLowerCase()} here…`}
                        maxLength={600}
                        rows={5}
                    />
                ) : text ? (
                    <p className="section-read-text">{text}</p>
                ) : (
                    <button className="section-empty-state" onClick={openEdit}>
                        Tap to add {title.toLowerCase()}…
                    </button>
                )}
            </div>
        </div>
    );
};

// ── Main InfoTab ──────────────────────────────────────────────────────────────
const InfoTab = ({ email }) => {
    const [aboutSection,    setAboutSection]    = useState('');
    const [servicesSection, setServicesSection] = useState('');
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        fetchBusinessPresentation(email).then(p => {
            if (p) {
                setAboutSection(p.about_section || '');
                setServicesSection(p.services_section || '');
            }
            setLoaded(true);
        });
    }, [email]); // eslint-disable-line react-hooks/exhaustive-deps

    const saveAbout    = async (text) => updateBusinessPresentation(email, text, servicesSection);
    const saveServices = async (text) => updateBusinessPresentation(email, aboutSection, text);

    return (
        <>
            <BusinessInfoCard email={email} />

            {loaded && (
                <>
                    <SectionCard
                        title="About Us"
                        icon={<IconPerson />}
                        gradient="linear-gradient(90deg, #1E1410, #4A3728)"
                        bodyShadow="0 4px 16px rgba(74,55,40,0.08)"
                        savedText={aboutSection}
                        onSave={async (text) => { await saveAbout(text); setAboutSection(text); }}
                    />
                    <SectionCard
                        title="Our Services"
                        icon={<IconStar />}
                        gradient="linear-gradient(90deg, #8A4F1A, #B8732A)"
                        bodyShadow="0 4px 16px rgba(184,115,42,0.08)"
                        savedText={servicesSection}
                        onSave={async (text) => { await saveServices(text); setServicesSection(text); }}
                    />
                </>
            )}

            <ManagedServiceBanner email={email} />
        </>
    );
};

export default InfoTab;
